import React from "react";
import {
  Box,
  Toolbar,
  AppBar,
  Container,
  useTheme,
  useMediaQuery,
  Stack,
} from "@mui/material";

const CustomNavbar = ({ leftContent, centerContent, rightContent }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <AppBar position="static" color="default" elevation={1}>
      <Container maxWidth="xl" disableGutters>
        <Toolbar
          disableGutters
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: { xs: 1, sm: 0 },
            minHeight: "56px", // Slim height
            px: 2,
            py: 1,
          }}
        >
          {/* Left Section */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "center", sm: "flex-start" },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            {leftContent}
          </Box>

          {/* Center Section */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              width: { xs: "100%", sm: "auto" },
            }}
          >
            {centerContent}
          </Box>

          {/* Right Section */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "center", sm: "flex-end" },
              width: { xs: "100%", sm: "auto" },
              gap: 1, // spacing between status and button
            }}
          >
            {rightContent}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default CustomNavbar;
